import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import Logo from '@jetbrains/ring-ui/components/header/logo';
import JunieLogoSVG from '@app/assets/junie-logo.svg';
import styles from './junie-logo.css';
export function JunieLogo({ className, size }) {
    return (_jsx(Logo, { glyph: JunieLogoSVG, className: classNames(styles.logo, className), size: size !== null && size !== void 0 ? size : 24 }));
}
